module.exports = __webpack_public_path__ + "img/40_69_002_350.d29bced5.jpg";